var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("header-programa", {
                    attrs: { programa: _vm.solicitud?.programa },
                  }),
                ],
                1
              ),
              _vm._v("s\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-overlay",
            { attrs: { show: false } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.productosGenerados"
                            ),
                            description: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.productosGeneradosDesc"
                            ),
                            "label-for": "form-productos-generados",
                          },
                        },
                        [
                          _c("b-form-checkbox-group", {
                            attrs: {
                              name: "form-productos-generados",
                              switch: "",
                              options: _vm.opcionesProductosGenerados,
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.resultadosForm.productosGenerados,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.resultadosForm,
                                  "productosGenerados",
                                  $$v
                                )
                              },
                              expression: "resultadosForm.productosGenerados",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.otroProducto"
                              ) + ":",
                            "label-for": "form-otro-producto",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-otro-producto",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.resultadosForm.otroProducto,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.resultadosForm,
                                  "otroProducto",
                                  $$v
                                )
                              },
                              expression: "resultadosForm.otroProducto",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.cantidad"
                              ) + ":",
                            "label-for": "form-cantidad",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-cantidad",
                              disabled: !_vm.esEscritura,
                              type: "number",
                            },
                            model: {
                              value: _vm.resultadosForm.cantidad,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.resultadosForm,
                                  "cantidad",
                                  _vm._n($$v)
                                )
                              },
                              expression: "resultadosForm.cantidad",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.resultadosAlcanzados"
                            ),
                            "label-for": "form-resultados-alcanzados",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-resultados-alcanzados",
                              rows: "4",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.resultadosForm.resultadosAlcanzados,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.resultadosForm,
                                  "resultadosAlcanzados",
                                  $$v
                                )
                              },
                              expression: "resultadosForm.resultadosAlcanzados",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.resultadosForm.resultadosAlcanzados.maxLength
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.maxlength", {
                                      max: 500,
                                    })
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.resultadosForm.resultadosAlcanzados.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.evidenciasDisponibles"
                            ),
                            "label-for": "form-evidencias-disponibles",
                          },
                        },
                        [
                          _c("b-form-checkbox-group", {
                            attrs: {
                              name: "form-evidencias-disponibles",
                              switch: "",
                              options: _vm.opcionesEvidenciasDisponibles,
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.resultadosForm.evidenciasDisponibles,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.resultadosForm,
                                  "evidenciasDisponibles",
                                  $$v
                                )
                              },
                              expression:
                                "resultadosForm.evidenciasDisponibles",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.otraEvidencia"
                            ),
                            "label-for": "form-otra-evidencia",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-otra-evidencia",
                              rows: "4",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.resultadosForm.otraEvidencia,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.resultadosForm,
                                  "otraEvidencia",
                                  $$v
                                )
                              },
                              expression: "resultadosForm.otraEvidencia",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.esEscritura
                ? _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            attrs: {
                              type: "button",
                              disabled: _vm.desactivarBoton,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.guardarResultados()
                              },
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.actividadesRetribucion.acciones.guardarSeccion"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }